module.exports = __webpack_public_path__ + "static/media/awake.c098d6e5.svg";